import { Rights } from '../rights';

export const KITCHEN_RIGHTS = Object.freeze([
  Rights.RESIDENTS.READ.key,
  Rights.RESIDENTS.GENERAL.READ.key,
  Rights.CARE.READ.key,
  Rights.CARE.WRITE.key,
  Rights.CARE.NUTRITION_PROTOCOL.READ.key,
  Rights.LISTS.READ.key,
  Rights.ROSTER.ACCESS.LIMITED_READ.key,
  Rights.ROSTER.VACATION_SCHEDULE.READ.key,
]);
